import {
    HttpResponse,
    QueryModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    PartyCreditModel,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse, CrudPartialUpdatePatch} from '@/libs/core/crud/crud-service';

export class PartyCreditsDataService implements CrudService<PartyCreditModel, PartyCreditModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<PartyCreditModel>): Promise<CrudListResponse<PartyCreditModel>> {
        return ApiService.api.getPartyCreditBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<PartyCreditModel>> {
        return ApiService.api.getPartyCreditById(id, params);
    }

    create(item: PartyCreditModel, params?: RequestParams): Promise<CrudResponse<PartyCreditModel>> {
        return ApiService.api.insertPartyCredit(item, params);
    }

    update(item: PartyCreditModel, params?: RequestParams): Promise<PartyCreditModel> {
        return ApiService.api.updatePartyCredit(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<PartyCreditModel> {
        return ApiService.api.patchPartyCredit(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<PartyCreditModel>): Promise<CrudListResponse<PartyCreditModel>> {
        return ApiService.api.deletePartyCredits(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<PartyCreditModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
